import React, { useState } from 'react'
import { Button, Space } from 'antd'
import { FileContent } from '../../../components/file-preview'
import { PreviewFile, PreviewDocumentLoader } from '../../../components/file-preview/files'
import { numberReadings } from './result-model'

export default function NumberEvidence({ readings, file, loader, onChoose }: {
  readings: ReturnType<typeof numberReadings>
  file: PreviewFile | null
  loader: PreviewDocumentLoader
  onChoose: (value: string) => void
}) {
  const [selected, setSelected] = useState(0)
  const current = readings[selected] ?? readings[0]
  return <section aria-label="Сверка номера с оригиналом">
    <p>На страницах прочитаны разные номера. Сверьте шапку оригинала и укажите номер накладной.</p>
    <Space wrap>
      {readings.map((read, index) => <Button size="small" key={index} aria-pressed={index === selected}
        type={index === selected ? 'primary' : 'default'} onClick={() => setSelected(index)}>
        Стр. {read.page} · {read.value}
      </Button>)}
      <Button size="small" type="link" onClick={() => onChoose(current.value)}>Подставить этот номер</Button>
    </Space>
    {file ? <div style={{ display: 'flex', height: 260, margin: '8px 0 16px' }}>
      <FileContent file={file} page={current.page} canvasPdf documentLoader={loader} />
    </div> : <p>Оригинал недоступен для просмотра.</p>}
  </section>
}
